/* -disable no-use-before-define */
import React from 'react';
import styled, { css } from 'styled-components';

import colors from '../../../colors';

const Container = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  overflow-y: hidden;
`;
const Header = styled.div`
  display: flex;
  ${Row} {
    padding: 4px 0;
  }
  ${Column} {
    font-size: 16px;
    font-weight: bold;
    color: var(--white);
  }
`;
const Column = styled.div`
  display: flex;
  align-items: center;
  padding: 0 12px;
  flex: ${({ flex }) => flex || 1};
  font-size: 16px;
  color: ${colors.grayText1};
  ${props =>
    props.plate &&
    css`
      font-size: 22px;
      color: var(--white);
    `}
`;
const Row = styled.div`
  display: flex;
  flex: 1;
`;
const Body = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  ${Row} {
    padding: 8px 0;
    border-top: 1px solid ${colors.border};
  }
`;

const VehiclesList = ({ vehicles }) => (
  <Container>
    <Header>
      <Row>
        <Column flex={2}>Placa</Column>
        <Column flex={4}>Tipo/Destino</Column>
      </Row>
    </Header>
    <Body>
      {vehicles &&
        vehicles.map((vehicle, key) => (
          // -disable-next-line react/no-array-index-key
          <Row key={key}>
            <Column flex={2} plate>
              {vehicle.plate}
            </Column>
            <Column flex={4}>
              {vehicle.type}
              <br />
              {vehicle.destination}
            </Column>
          </Row>
        ))}
    </Body>
  </Container>
);

export default VehiclesList;
